import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';

const PRIORITY_VARIANT = { high: 'danger', medium: 'warning', low: 'neutral' };

// Matches the in-app Next Steps cards: light gray box with a teal left rail,
// the action as the headline, "Owner:" / "When:" inline below, priority chip
// at the bottom. Replaces an older 4-column table layout that didn't match
// the rest of the report visually.
const NextStepsTable = ({ steps = [] }) => (
  <View style={{ marginTop: space.sm }}>
    {steps.map((s, i) => (
      <View key={i} wrap={false} style={{
        flexDirection: 'row',
        backgroundColor: '#f5f7fa',
        borderRadius: 4,
        overflow: 'hidden',
        marginBottom: i === steps.length - 1 ? 0 : space.sm,
      }}>
        <View style={{ width: 3, backgroundColor: colors.teal }} />
        <View style={{ flex: 1, paddingVertical: 10, paddingHorizontal: space.md }}>
          <Text style={[type.bodyMed, { color: colors.ink }]}>{s.action}</Text>
          {(s.owner || s.when) && (
            <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
              {s.owner && <Text style={{ fontWeight: 600, color: colors.ink }}>Owner: </Text>}
              {s.owner && <Text>{s.owner}</Text>}
              {s.owner && s.when && <Text>  ·  </Text>}
              {s.when && <Text style={{ fontWeight: 600, color: colors.ink }}>When: </Text>}
              {s.when && <Text>{s.when}</Text>}
            </Text>
          )}
          {s.priority && (
            <View style={{ alignSelf: 'flex-start', marginTop: 6 }}>
              <Chip variant={PRIORITY_VARIANT[s.priority] || 'neutral'}>
                {s.priority} priority
              </Chip>
            </View>
          )}
        </View>
      </View>
    ))}
  </View>
);

export default NextStepsTable;
